import { AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TargetBlankDirective } from '@app/core/misc/directives/target-blank.directive';
import { PricePipe } from '@app/core/pipes/price.pipe';
import { GalleryItemsLoadMoreComponent } from '@app/entities/images/components/gallery-items-load-more/gallery-items-load-more.component';
import { Order } from '@app/entities/orders/interfaces/order';
import { EmptyBlockComponent } from '@app/layout/empty-block/empty-block.component';
import { NavService } from '@app/services/nav.service';
import { DownloadsSelectors, LoadDownloads } from '@app/store';
import { Store } from '@ngxs/store';
import { filter, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-account-downloads-page',
  templateUrl: './account-downloads.page.html',
  styleUrls: ['./account-downloads.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    PricePipe,
    DatePipe,
    AsyncPipe,
    GalleryItemsLoadMoreComponent,
    EmptyBlockComponent,
    TargetBlankDirective,
  ],
  providers: [CurrencyPipe],
})
export class AccountDownloadsPage implements OnInit {
  constructor(
    private navService: NavService,
    private store: Store,
  ) {}

  @Input()
  partialView: boolean = false;

  @Input()
  mb30: boolean = false;

  protected stateOrders$: Observable<Order[] | undefined> = this.store.select(
    DownloadsSelectors.orders,
  );

  protected orders$!: Observable<Order[]>;

  protected totalCount$: Observable<number | undefined> = this.store.select(
    DownloadsSelectors.totalCount,
  );

  protected hasMoreResults$: Observable<boolean> = this.store.select(
    DownloadsSelectors.hasMoreResults,
  );

  ngOnInit(): void {
    this.orders$ = this.stateOrders$.pipe(
      filter((orders: Order[] | undefined) => {
        return orders !== undefined;
      }),
    );

    this.store.dispatch(new LoadDownloads());

    if (this.partialView) {
      return;
    }

    if (!this.partialView) {
      this.navService.setNavItems([
        { label: 'Account', route: '/account' },
        { label: 'Downloads' },
      ]);
    }
  }

  protected onLoadMore(): void {
    this.store.dispatch(new LoadDownloads(true));
  }
}
